/**
 * Invite Page
 */
import { useParams } from "react-router-dom";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import { useTranslations } from "@/hooks/use-translations";

export function InvitePage() {
	const { id } = useParams<{ id: string }>();
	const t = useTranslations("invite");

	return (
		<div className="min-h-screen bg-bg-canvas flex items-center justify-center p-6">
			<div className="w-full max-w-lg">
				<Card>
					<CardHeader className="text-center">
						<CardTitle className="text-2xl">{t("title")}</CardTitle>
						<CardDescription>{t("subtitle")}</CardDescription>
					</CardHeader>
					<CardContent className="space-y-4">
						<p className="text-text-secondary text-center">
							{t("invitationId")} {id}
						</p>
						<div className="flex gap-3">
							<Button asChild variant="outline" className="flex-1">
								<Link href="/login">{t("signIn")}</Link>
							</Button>
							<Button asChild className="flex-1">
								<Link href="/signup">{t("signUp")}</Link>
							</Button>
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	);
}
